import React from 'react'
import home from '../../../database/pages/home.json'

const SectionStoryMap = () => {
  return (
    <div>
      <iframe
        src={home.storyMapUrl}
        frameBorder="0"
        width="100%"
        height="720"
        title="story-map"
      ></iframe>
    </div>
  )
}

export { SectionStoryMap }